import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imports-list',
  templateUrl: './imports-list.component.html',
  styleUrls: ['./imports-list.component.css']
})
export class ImportsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
